export class ExceptionReportApiModel {
  ReportAPI: string;
  AppTrackingAPI: string;
}
